import type { ReactNode } from 'react';
import type { ClaimType } from '../../types/report';
import { useReportPanel } from '../../state/reportPanel';

interface ClaimProps {
  id: string;
  type: ClaimType;
  children: ReactNode;
}

// Affordance per claim type (Click-to-Drill PRD §2.1): data claims get a teal
// underline; entities/cells get a subtle hover only (permanent affordance would
// clutter). All are clickable.
const AFFORDANCE: Record<ClaimType, string> = {
  A: 'underline decoration-dotted decoration-teal-500 underline-offset-2 hover:decoration-solid hover:bg-teal-50',
  B: 'cursor-pointer hover:drop-shadow-sm',
  C: 'cursor-pointer hover:bg-slate-50',
  D: 'cursor-pointer hover:text-teal-700',
  E: 'cursor-pointer hover:bg-slate-50',
};

export function Claim({ id, type, children }: ClaimProps) {
  const { open } = useReportPanel();
  return (
    <span
      role="button"
      tabIndex={0}
      data-claim={id}
      data-claim-type={type}
      className={`cursor-pointer ${AFFORDANCE[type]}`}
      onClick={() => open(id)}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          open(id);
        }
      }}
    >
      {children}
    </span>
  );
}
